/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: external-metadata-resource-factory
 *
 * Created by rwilliams on 10/5/17.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ExternalMetadataResourceFactory', function ($resource, EndPointService) {
	return $resource(EndPointService.externalMetadataSourcesEndPoint + '/:id', {id: '@id'}, {
		save: {
			method: 'POST',
			url: EndPointService.externalMetadataSourcesEndPoint,
			isArray: false
		},
		update: {
			method: 'PUT',
			url: EndPointService.externalMetadataSourcesEndPoint + '/:id',
			isArray: false
		},
        run: {
            method: 'POST',
            url: EndPointService.externalMetadataSourcesEndPoint + '/:id/jobs',
            isArray: true,
            headers: {
                'Content-Type': 'application/xml',
            },
        },
	});
});
